import {createTheme, responsiveFontSizes} from "@mui/material/styles";
import {COLOR_AZUL_OSCURO, COLOR_VERDE_ARTECO} from "./colors";
import {esES} from "@mui/material/locale";
import {alpha, lighten} from "@mui/material";

// import "../../../public/fonts/Manrope/Manrope-VariableFont_wght.ttf";

const components = {
    MuiLink: {
        defaultProps: {
            underline: "none",
        },
    },
    // Kit común (#13879): las etiquetas de color, en suave (fondo tintado y texto del color) en lugar
    // de bloques macizos. Las que se pulsan (filtros) siguen macizas para que se vea la elegida.
    MuiChip: {
        styleOverrides: {
            root: ({ownerState, theme}: any) => {
                const c = ownerState.color;
                if (ownerState.variant === "outlined" || ownerState.clickable || !c || c === "default") {
                    return {fontWeight: 600};
                }
                const main = theme.palette[c]?.main;
                if (!main) {
                    return {fontWeight: 600};
                }
                return {
                    fontWeight: 600,
                    backgroundColor: alpha(main, 0.12),
                    color: theme.palette[c].dark,
                    border: `1px solid ${alpha(main, 0.25)}`,
                };
            },
        },
    },
    // Kit común (#13877): botones sin mayúsculas forzadas ni sombra, en todo el admin.
    MuiButton: {
        defaultProps: {
            disableElevation: true,
        },
        styleOverrides: {
            root: {textTransform: "none", fontWeight: 600, borderRadius: 8},
        },
    },
    MuiCssBaseline: {
        styleOverrides: `
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: url("/public/fonts/Manrope/Manrope-Variablefont_wght.ttf") format('truetype');
        }
      `,
    }

} as any;

export const theme = responsiveFontSizes(
    createTheme({
        components: components,
        palette: {
            primary: {
                main: lighten(COLOR_AZUL_OSCURO,.3),
            },
            secondary: {
                main: COLOR_VERDE_ARTECO,
            },
            text: {
                primary: COLOR_AZUL_OSCURO,
            },
        },
        typography: {
            fontFamily: [
                "Manrope",
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                "sans-serif",
            ].join(","),
        },
    }, esES)
);


